import { WebGLRenderer, NoToneMapping, SRGBColorSpace } from 'three';
import { getCanvas } from '../ui/dom';

export function createRenderer(): WebGLRenderer {
  const canvas = getCanvas();

  const renderer = new WebGLRenderer({
    canvas,
    antialias: false,
    powerPreference: 'high-performance',
    stencil: false,
  });

  renderer.toneMapping = NoToneMapping;
  renderer.outputColorSpace = SRGBColorSpace;
  renderer.setPixelRatio(1);
  renderer.info.autoReset = false;

  return renderer;
}
